import clsx from "clsx";

export function ProgressBar({
  value,
  label,
  title,
  reverse = false,
  component,
}: {
  value: number;
  label?: string;
  title?: string;
  reverse?: boolean;
  component?: "inventory" | string;
}) {
  const getBarColor = () => {
    // Strict 3-color logic for Inventory: Red -> Orange -> Green
    if (component === "inventory") {
      if (value <= 20) return "bg-red-500";
      if (value > 20 && value < 99) return "bg-orange-500"; // Red for low stock
      if (value >= 100) return "bg-green-500"; // Orange for mid stock
      return "bg-emerald-500"; // Green for healthy stock
    }

    // Default logic for other components
    if (reverse) {
      if (value > 75) return "bg-emerald-500";
      if (value > 50) return "bg-blue-400";
      if (value > 25) return "bg-orange-500";
      return "bg-yellow-500";
    } else {
      if (value > 85) return "bg-red-500";
      if (value > 65) return "bg-amber-500";
      return "bg-emerald-500";
    }
  };

  return (
    <div className="flex flex-col gap-1 w-full">
      {(label || title) && (
        <div className="flex justify-between text-xs text-[rgb(var(--text-muted))]">
          <span>{title}</span>
          <span>{label}</span>
        </div>
      )}

      <div className="h-2 bg-[rgb(var(--card-muted))] rounded-full overflow-hidden">
        <div
          className={clsx(
            "h-full rounded-full transition-all duration-500",
            getBarColor(),
          )}
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
}
